import { Component, OnInit, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { Enums } from '@cyborg-monorepo/hunter/common'
import { SelectOption } from '@hyperkit'

import { sortDisplayName } from '../../../../helpers/display-names'
import { SearchStateService } from '../../../research/services/search-state.service'

@Component({
  standalone: false,
  selector: 'cyborg-search-sort',
  templateUrl: './search-sort.component.html',
  styleUrls: ['./search-sort.component.scss'],
})
export class SearchSortComponent implements OnInit {
  searchStateService = inject(SearchStateService)

  public options: SelectOption[]
  public sort$: Observable<Enums.CyborgSortEnum>
  public sort: Enums.CyborgSortEnum

  public ngOnInit(): void {
    this.sort$ = this.searchStateService.state.pipe(map((state) => state.sort))

    this.sort$.subscribe((value) => {
      this.sort = value // ← set initial value for ngModel
    })

    this.options = Object.keys(Enums.CyborgSortEnum).map((key) => {
      return {
        id: Enums.CyborgSortEnum[key],
        text: sortDisplayName(Enums.CyborgSortEnum[key]),
      }
    })
  }

  public onSelect(sortValue: Enums.CyborgSortEnum): void {
    this.sort = sortValue
    this.searchStateService.setSort(sortValue)
  }
}
